<script setup lang="ts">
import { useRoute } from "vue-router";
import { ref, onMounted } from "vue";
import RvApi from "@/rvapi";

const route = useRoute();
const orderId = route.params.id as string;
const loaded = ref(false);
const working = ref(false);
const downloadUrl = ref("");

onMounted(async () => {
  downloadUrl.value = await RvApi.dataExportLink(orderId);
  loaded.value = true;
});
</script>

<template>
  <h2>Order data export</h2>
  <h3>{{ orderId }}</h3>
  <p>
    This will combine the order payment data, the receiver list, and - if it
    still exists - the image data, all into one zipfile presented for download.
  </p>
  <p>
    This zipfile can be attached to an email and sent to sakerhet@postnord.com
    upon request. Do not send it anywhere else, instead direct all police
    requests for information to sakerhet.
  </p>
  <p v-show="!loaded">
    <pn-spinner />
    The download link is being created
  </p>
  <section v-if="loaded">
    <pn-button :href="downloadUrl" :loading="working">Download</pn-button>
  </section>
</template>
